import pb from "../../lib/pb";

const ProductVariantService = {

    async listByProduct(productId) {

        if (!productId) {
            return [];
        }

        return await pb
            .collection("product_variants")
            .getFullList({
                filter: `product="${productId}"`,
                sort: "created"
            });

    },

    async get(id) {

        return await pb
            .collection("product_variants")
            .getOne(id);

    },

    async create(data) {

        return await pb
            .collection("product_variants")
            .create(data);

    },

    async update(id, data) {

        return await pb
            .collection("product_variants")
            .update(
                id,
                data
            );

    },

    async remove(id) {

        return await pb
            .collection("product_variants")
            .delete(id);

    },

    async updateStock(id, stock) {

        return await pb
            .collection("product_variants")
            .update(
                id,
                {
                    stock
                }
            );

    },

    /*
    --------------------------------------------------
    Realtime Subscription
    --------------------------------------------------
    */

    subscribe(productId, callback) {

        if (!productId || !callback) {
            return null;
        }

        return pb
            .collection("product_variants")
            .subscribe(
                "*",
                event => {

                    if (
                        event?.record?.product === productId
                    ) {

                        callback(event);

                    }

                }
            );

    },

    /*
    --------------------------------------------------
    Realtime Unsubscribe
    --------------------------------------------------
    */

    async unsubscribe() {

        await pb
            .collection("product_variants")
            .unsubscribe();

    }

};

export default ProductVariantService;